import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-hot-toast";
import { CREATE_PRICE_API,GET_PRICE_API,SUBMIT_PRICE_API, UPLOAD_PRICE_API } from "src/config/apiConfig";
import { PriceRequest, SubmitRequest } from "src/models/master_data/price/price.dto";

export const fetchMsPriceThunk = createAsyncThunk(
    'msPrice/fetchMsPriceThunk',
    async ({ pageNumber, pageSize }: { pageNumber: number, pageSize: number }, thunkAPI) => {
        try {        
            const accessToken = localStorage.getItem('userToken');

            // Set authorization header
            const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

            // Make the API request
            const response = await axios.get(GET_PRICE_API, {
                params: {
                    PageNumber: pageNumber,
                    PageSize: pageSize,
                },
                headers,
            });
            if (response.status === 200) {
                return { data: response.data };
            } else {
                toast.error('Failed to fetch price');
                return thunkAPI.rejectWithValue('Failed to fetch price');
            }
        } catch (error: any) {
            toast.error(error.response?.data?.errorMessage || 'An error occurred while fetching price');
            console.log(error)
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const createMsPriceThunk = createAsyncThunk(
    'msPrice/createMsPriceThunk',
    async (priceData: PriceRequest, thunkAPI) => {
        try {
            const response = await axios.post(CREATE_PRICE_API, priceData);
            if (response.status === 200 || response.status === 201) {
                toast.success('Item created successfully');
                return { data: response.data };
            } else {
                toast.error('Failed to create item');
                return thunkAPI.rejectWithValue('Failed to create price');
            }
        } catch (error: any) {
            toast.error(error.response?.data?.errorMessage || 'An error occurred while creating the price');
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const uploadMsPriceThunk = createAsyncThunk(
    'msPrice/uploadMsPriceThunk',
    async (file: File, thunkAPI) => {
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await axios.post(UPLOAD_PRICE_API, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (response.status === 200) {
                toast.success('File uploaded successfully');
                return { data: response.data };
            } else {
                toast.error('Failed to upload file');
                return thunkAPI.rejectWithValue('Failed to upload file');
            }
        } catch (error: any) {
            toast.error(error.response?.data?.errorMessage || 'An error occurred while uploading the file');
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const submitMsPriceThunk = createAsyncThunk(
    'msPrice/submitMsPriceThunk',
    async (submitData: SubmitRequest, thunkAPI) => {
        try {
            const response = await axios.post(SUBMIT_PRICE_API, submitData);
            if (response.status === 200) {
                toast.success('Items submitted successfully');
                return { data: response.data };
            } else {
                toast.error('Failed to submit items');
                return thunkAPI.rejectWithValue('Failed to submit items');
            }
        } catch (error: any) {
            toast.error(error.response?.data?.errorMessage || 'An error occurred while submitting items');
            return thunkAPI.rejectWithValue(error);
        }
    }
);